import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, X } from "lucide-react";

const SWIPE_OUT = 90;

// One alert row: tap to open, tap X or swipe left/right to remove.
export function SwipeAlert({ n, Icon = Bell, onRemove }) {
  const start = useRef(null);
  const moved = useRef(false);
  const dxRef = useRef(0);
  const [dx, setDx] = useState(0);
  const [leaving, setLeaving] = useState(0);

  const remove = (dir = 1) => { setLeaving(dir); setTimeout(() => onRemove(n.id), 180); };
  const onTouchStart = (e) => { start.current = e.touches[0].clientX; moved.current = false; dxRef.current = 0; };
  const onTouchMove = (e) => {
    if (start.current === null) return;
    const d = e.touches[0].clientX - start.current;
    if (Math.abs(d) > 8) moved.current = true;
    dxRef.current = d;
    setDx(d);
  };
  const onTouchEnd = () => {
    if (Math.abs(dxRef.current) > SWIPE_OUT) remove(Math.sign(dxRef.current));
    else setDx(0);
    start.current = null;
  };

  const offset = leaving ? leaving * 420 : dx;
  return (
    <div data-testid={`notification-row-${n.id}`} className="relative overflow-hidden rounded-2xl">
      <div className="absolute inset-0 rounded-2xl bg-[#FF3B6B]/20 flex items-center justify-end px-5 text-xs font-semibold text-[#FF7A7A]">Remove</div>
      <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}
        style={{ transform: `translateX(${offset}px)`, opacity: leaving ? 0 : 1 - Math.min(Math.abs(dx) / 400, 0.5) }}
        className={`relative flex items-center gap-2 rounded-2xl border pr-2 ${dx && !leaving ? "" : "transition-[transform,opacity] duration-200"} ${n.read ? "bg-[#151C2C] border-[#26334D]" : "bg-[#0F1F24] border-[#00E5A3]/40"}`}>
        <Link to={n.link} data-testid={`notification-${n.id}`} onClick={(e) => moved.current && e.preventDefault()}
          className="flex flex-1 min-w-0 items-center gap-3 p-4 rounded-2xl hover:text-white">
          <span className="h-9 w-9 rounded-xl bg-[#FF3B6B]/15 text-[#FF3B6B] grid place-items-center shrink-0"><Icon className="h-4 w-4" /></span>
          <span className="flex-1 text-sm">{n.text}</span>
          <span className="text-xs text-slate-500 shrink-0">{new Date(n.created_at).toLocaleDateString()}</span>
        </Link>
        <button data-testid={`notification-remove-${n.id}`} onClick={() => remove(1)} aria-label="Remove alert"
          className="h-10 w-10 shrink-0 grid place-items-center rounded-full text-slate-500 hover:text-white hover:bg-white/5 active:scale-90 transition-transform">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
